import { Action } from '@ngrx/store';
import { AuthorizationSecurityError } from '../../../core/model/authorization/authorization-security-error.enum';
import { AuthorizationResponse } from '../../../core/model/authorization/authorization-response.model';
import { SignInfo } from '../../../core/model/authorization/sign-info.model';
import { AuthorizationStatus } from '../../../core/model/authorization/authorization-status.model';
import { EnableConsent } from '../model/enable-consent.model';

/**
 * Actions related to consent enabling - requires authorization:
 *
 * 1. POST to initiate change request
 * 2. MEP authorization in IFrame
 * 3. Get Status from backend
 */

// initial POST
export const ENABLE_CONSENT_REQUEST = '[Enable Consent] Request';
export const ENABLE_CONSENT_SUCCESS = '[Enable Consent] Success';
export const ENABLE_CONSENT_ERROR =   '[Enable Consent] Error';

// popup close
export const ENABLE_CONSENT_CANCEL =      '[Enable Consent] Cancel';
export const ENABLE_CONSENT_AUTH_ERROR =  '[Enable Consent] Auth Error';

// MEP authorization in IFrame
export const ENABLE_CONSENT_AUTH_FINISHED = '[Enable Consent] Auth Finished';

// finalization GET status
export const ENABLE_CONSENT_STATUS_REQUEST = '[Enable Consent] Status Request';
export const ENABLE_CONSENT_STATUS_SUCCESS = '[Enable Consent] Status Success';
export const ENABLE_CONSENT_STATUS_ERROR =   '[Enable Consent] Status Error';

// clean state
export const ENABLE_CONSENT_CLEAN =  '[Enable Consent] Clean';

/**
 * Request to enable consent.
 */
export class EnableConsentRequestAction implements Action {
    readonly type = ENABLE_CONSENT_REQUEST;
}

/**
 * Request enable success action.
 * MEP authorization follows.
 */
export class EnableConsentSuccessAction implements Action {
    readonly type = ENABLE_CONSENT_SUCCESS;

    constructor(public payload: EnableConsent) {}
}

/**
 * Request enable error action.
 */
export class EnableConsentErrorAction implements Action {
    readonly type = ENABLE_CONSENT_ERROR;

    constructor(public payload: any) {}
}

// ---------------------------------------------------------------------------------------------------------------------

/**
 * Cancel enable consent.
 */
export class EnableConsentCancelAction implements Action {
    readonly type = ENABLE_CONSENT_CANCEL;
}

/**
 * Authorization error.
 */
export class EnableConsentAuthErrorAction implements Action {
    readonly type = ENABLE_CONSENT_AUTH_ERROR;

    constructor(public payload: AuthorizationSecurityError) {}
}

/**
 * IFrame authorization finished.
 */
export class EnableConsentAuthFinishedAction implements Action {
    readonly type = ENABLE_CONSENT_AUTH_FINISHED;

    constructor(public payload: AuthorizationResponse) {};
}

// ---------------------------------------------------------------------------------------------------------------------

/**
 * Get authorization status - it is required to fetch authorization status from BE.
 */
export class EnableConsentStatusRequestAction implements Action {
    readonly type = ENABLE_CONSENT_STATUS_REQUEST;

    constructor(public payload: SignInfo) {}
}

/**
 * Get authorization status - success.
 *
 * Success means that status has been fetched. It does not mean successful authorization in MEP.
 * Payload contains MEP authorization status / result.
 */
export class EnableConsentStatusSuccessAction implements Action {
    readonly type = ENABLE_CONSENT_STATUS_SUCCESS;

    constructor(public payload: AuthorizationStatus) {}
}

/**
 * Get authorization status - error.
 */
export class EnableConsentStatusErrorAction implements Action {
    readonly type = ENABLE_CONSENT_STATUS_ERROR;

    constructor(public payload: any) {}
}

// ---------------------------------------------------------------------------------------------------------------------

/**
 * Clean authorization store.
 */
export class EnableConsentCleanAction implements Action {
    readonly type = ENABLE_CONSENT_CLEAN;
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions
    = EnableConsentRequestAction
    | EnableConsentSuccessAction
    | EnableConsentErrorAction
    | EnableConsentCancelAction
    | EnableConsentAuthErrorAction

    | EnableConsentAuthFinishedAction

    | EnableConsentStatusRequestAction
    | EnableConsentStatusSuccessAction
    | EnableConsentStatusErrorAction
    | EnableConsentCleanAction;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/consent/actions/enable-consent.actions.ts